// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://wpnlnamnpxykgdtsfohh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndwbmxuYW1ucHh5a2dkdHNmb2hoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQzODUyMjksImV4cCI6MjA2OTk2MTIyOX0.KmEhwRhSUr8Mkl_1y7UF0EIn0wf-obtgkogzcoOPWag";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});